import { CreateSubtypeRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateCategoryRequest';
import { createSubtypeHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/SubtypeHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateSubtype = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createSubtypeHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateSubtypeRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subtypes'] });
    },
  });
};
